import type { CountryCodeAndCallingCode } from "@/components/shared/CustomPhoneNumber/types.ts";
import { getCountries, getCountryCallingCode } from "libphonenumber-js";
import { US } from "./constants.ts";

export const getCountryOptions = () => {
  const regionNames = new Intl.DisplayNames([], { type: "region" });
  const countryCodes = getCountries();
  const countryOptions = countryCodes.reduce<CountryCodeAndCallingCode[]>((acc, currentValue) => {
    if (currentValue !== US) {
      acc.push({
        id: currentValue,
        countryCallingCode: getCountryCallingCode(currentValue),
        label: regionNames.of(currentValue) ?? "",
      });
    }
    return acc;
  }, []);

  countryOptions.unshift({
    id: US,
    countryCallingCode: getCountryCallingCode(US),
    label: regionNames.of(US) ?? "",
  });
  return countryOptions;
};
